module.exports = __webpack_public_path__ + "img/SFKJ.60dfd06e.png";